/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAccountWelcomeTileViewProps } from './account-welcome-tile';

const AccountWelcomeTileView: React.FC<IAccountWelcomeTileViewProps> = props => {
    const { AccountWelcomeTile, heading } = props;

    return (
        <Module {...AccountWelcomeTile}>
            {heading}
        </Module>
    );
};

export default AccountWelcomeTileView;
